module.exports = "/images/vendor/flag-icon-css/flags/1x1/hr.svg?88f38f33e9c5dd75280aadbd2b8d60a5";